<script setup lang="ts">
import { CheckboxItem } from '@shared/ui/checkbox'

import { useTutorApplicationStore } from '../../model/store'
import { useAcceptConfidentiality } from '../../model/legal-agreements/accept-confidentiality.hooks'

defineOptions({
  name: 'AcceptConfidentiality',
})

const tutorApplicationStore = useTutorApplicationStore()

const {
  label,
  mode,
  setAcceptConfidentiality,
} = useAcceptConfidentiality()

</script>

<template>
  <CheckboxItem
    :label="label"
    required
    :checked="tutorApplicationStore.acceptConfidentiality"
    :mode="mode"
    @click="setAcceptConfidentiality"
  />
</template>
